// src/masterLayout/MenuConfig.jsx

export const menuConfig = [
  {
    label: null,
    items: [
      {
        label: "Tổng quan",
        to: "/client/dashboard",
        icon: "tabler:align-box-right-bottom-filled",
      },
      {
        label: "Bảng giá",
        to: "/client/pricetable",
        icon: "mynaui:dollar-hexagon-solid",
      },
    ],
  },
  {
    label: "TÀI KHOẢN",
    items: [
      {
        label: "Thống kê",
        icon: "mynaui:align-bottom-solid",
        eventKey: "0", // <-- THÊM DÒNG NÀY
        dropdown: [
          {
            label: "Giao dịch ngân hàng",
            to: "/client/banktrans",
            color: "success-800",
          },
          {
            label: "Giao dịch đơn hàng",
            to: "/client/transaction",
            color: "success-800",
          },
        ],
      },
      {
        label: "Ngân hàng",
        to: "/client/bank",
        icon: "majesticons:library",
      },
    ],
  },
  {
    label: "CÁ NHÂN",
    items: [
      {
        label: "Hồ sơ",
        to: "/client/profile",
        icon: "majesticons:document-award",
      },
      {
        label: "Hóa đơn",
        to: "/client/invoice",
        icon: "majesticons:paper-fold-text",
      },
    ],
  },
  {
    label: "TIẾP THỊ LIÊN KẾT",
    items: [
      {
        label: "Tổng quan",
        to: "/client/affiliate",
        icon: "majesticons:git-fork",
      },
      {
        label: "Rút tiền",
        to: "/client/affwithdraw",
        icon: "hugeicons:money-send-square",
      },
    ],
  },
  {
    label: "DÀNH CHO LẬP TRÌNH",
    items: [
      {
        label: "Webhooks",
        icon: "mdi:webhook",
        eventKey: "1", // <-- THÊM DÒNG NÀY
        dropdown: [
          {
            label: "Danh sách webhook",
            to: "/client/webhook",
            color: "success-800",
          },
          {
            label: "Lịch sử giao dịch",
            to: "/client/webhook-history",
            color: "success-800",
          },
        ],
      },
      {
        label: "LarkSuite",
        to: "/client/larksuite",
        icon: "mdi:bird",
      },
      {
        label: "Telegram",
        to: "/client/telegram",
        icon: "mdi:telegram",
      },
      {
        label: "Tạo mã QR",
        to: "/client/qrcreate",
        icon: "mdi:qrcode",
      },
    ],
  },
  {
    label: null,
    items: [
      {
        label: "Tích hợp",
        icon: "mdi:link-variant",
        dropdown: [
          {
            label: "Website/Application",
            to: "/client/integration/webapp",
            icon: "mdi:web",
          },
          {
            label: "Woocommerce",
            external: true,
            url: "https://docs.pay2s.vn/integrations/woocommerce.html",
            icon: "mdi:wordpress",
          },
          {
            label: "WHMCS",
            external: true,
            url: "https://docs.pay2s.vn/integrations/whmcs.html",
            icon: "mdi:server",
          },
          {
            label: "HostBill",
            external: true,
            url: "https://docs.pay2s.vn/integrations/hostbill.html",
            icon: "mdi:cloud",
          },
          {
            label: "Ezyplatform",
            external: true,
            url: "https://ezyplatform.com/market/items/ezypayment",
            icon: "mdi:application",
          },
        ],
      },
    ],
  },
];
